<div class="modal-header border-bottom border-secondary">
  <h4 class="modal-title text-light pull-left">User Settings</h4>
  <button type="button" class="btn-close btn-close-white pull-right" aria-label="Close" (click)="close()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body bg-dark text-light">
  <div class="mb-4">
    <h5>Preferences</h5>
    <div class="form-check form-switch mt-3">
      <input class="form-check-input" type="checkbox" role="switch" id="chatbotToggle" [(ngModel)]="isChatbotVisible" (change)="toggleChatbot()">
      <label class="form-check-label ms-2" for="chatbotToggle" style="cursor: pointer;">
        Enable AI Chatbot
      </label>
    </div>
    <small class="text-muted d-block mt-1 ms-1">
      Toggling this off will hide the floating chatbot icon in the bottom right corner of your screen.
    </small>
  </div>
</div>
<div class="modal-footer border-top border-secondary bg-dark">
  <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
</div>
